import { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface INewBuildDetails {
  statusText?: string;
}

export const NewBuildDetails: FC<INewBuildDetails> = ({ statusText }) => {
  const classes = useStyles();

  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.readOnlyHeaders} variant="h6">
            Build Info
          </Typography>
          <Typography variant="subtitle1">
            <span className={classes.detailsLabel}>Status:</span> {statusText} <br />
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  readOnlyHeaders: {
    paddingBottom: theme.spacing(0.25),
    fontWeight: '700'
  },
  detailsLabel: {
    fontWeight: 'bold'
  }
}));
